<template>
    <button 
        :form="formId" 
        :type="buttonType" 
        :disabled="disabled" 
        :class="
            { 
                primary_button: buttonClass == 'primary', 
                secondary_button: buttonClass == 'secondary', 
                tertiary_button: buttonClass == 'tertiary', 
                xxlarge: xxlarge,
                xlarge: xlarge,
                large: large,
                medium: medium,
                small: small,
                xsmall: xsmall,
                xxsmall: xxsmall,
                disabled_button: disabled
            }" 
    >
        <div class="text_wrapper">
            <span v-if="iconName" class="icon material-icons">{{ iconName }}</span> 
            <font-awesome-icon v-if="awesomeIcon" class="icon" :icon="awesomeIcon" />
            {{ buttonText }}
        </div>
    </button>
</template>

<script>
export default {
    props: [
        "small", 
        "large", 
        "xsmall", 
        "formId", 
        "medium", 
        "xlarge", 
        "xxsmall", 
        "xxlarge", 
        "iconName", 
        "disabled", 
        "buttonText", 
        "buttonType", 
        "awesomeIcon", 
        "buttonClass"
    ]
}
</script>

<style scoped>
button {
    padding: 9px 0;
    border-width: 0;
    border-radius: 3px;
}

button:hover {
    cursor: pointer;
}

.disabled_button.primary_button,
.disabled_button.primary_button:hover {
    background-color: var(--sniffer-color-primary-disabled) !important;
}

.disabled_button:hover {
    cursor: default !important;
}

.primary_button {
    color: white;
    background-color: var(--sniffer-color-primary);
}

.primary_button:hover {
    background-color: var(--sniffer-color-primary-hover);
}

.secondary_button {
    color: white;
    background-color: var(--sniffer-color-secondary);
}

.secondary_button:hover {
    background-color: var(--sniffer-color-secondary-hover);
}

.tertiary_button {
    background-color: white;
    border: 1px solid var(--sniffer-color-dark-grey);
}

.tertiary_button:hover {
    background-color: var(--sniffer-color-dark-grey);
}

.xxlarge {
    width: 100%;
}

.xlarge {
    width: 85%;
}

.large {
    width: 62%;
}

.medium {
    width: 50%;
}

.small {
    width: 35%;
}

.xsmall {
    width: 19%;
}

.xxsmall {
    width: 10%;
}

.text_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}

.icon {
    font-size: 18px;
}
</style>